export default function Hero() {
  const scrollToServices = () => {
    const servicesSection = document.getElementById("services");
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.hash = "#services";
    }
  };

  return (
    <section id="hero" className="hero">
      <h2>Welcome to AROCL CUSTOMS SOLUTIONS PRIVATE LIMITED</h2>
      <p>Delivering seamless warehousing, logistics, and transportation support solutions that keep supply chains moving efficiently.</p>
      <button type="button" onClick={scrollToServices}>Explore Services</button>
    </section>
  );
}
